module.exports = require("colors");


//////////////////
// WEBPACK FOOTER
// external "colors"
// module id = 5
// module chunks = 0